<div *ngIf="mostrarLabel">
  <i class="fa fa-check-circle margin-left-5" style="color: green;"></i> Conglomerado
  <ng-template #popContent>
  <bn-dica>
    <table class="table table-bordered table-striped">
      <thead>
        <th style="width: 15%;" class="text-center">Agente Financeiro</th>
        <th style="width: 15%; text-align: center;">Percentual</th>
      </thead>
      <tbody>
        <tr *ngFor="let element of participantesConglomerado" style="text-align: center;">
          <td class="text-start">
            {{ element.agenteFinanceiro.sigla }}
          </td>
          <td>
            {{ element.percentual | percent: '2.2-4' }}
          </td>
        </tr>
      </tbody>
    </table>
  </bn-dica>
  </ng-template>
  <i [ngbPopover]="popContent" class="fa fa-info-circle clickable" triggers="mouseenter:mouseleave"></i>
</div>
